export default "__VITE_ASSET__b8f58ea2__"